import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({
	providedIn: 'root'
})
export class BrowserNotificationService {
	private permissionPromise: Promise<NotificationPermission>;

	constructor(private location: Location) {}

	public createBrowserNotification(title: string, body: string, requireInteraction: boolean): Promise<Notification> {
		return this.getPermission().then((result) => {
			if (result == 'granted') {
				return new Notification(title, {
					badge: this.location.prepareExternalUrl('assets/images/ht-logo.png'),
					body: body,
					icon: this.location.prepareExternalUrl('assets/images/ht-logo.png'),
					requireInteraction: requireInteraction
				});
			} else {
				return Promise.resolve(null);
			}
		});
	}

	public getPermission(): Promise<NotificationPermission> {
		if (!this.permissionPromise) {
			this.permissionPromise = Notification.requestPermission();
		}

		return this.permissionPromise;
	}
}
